const PaymentMethod = [
  {
    path: '/ecommerce/settings/payment-methods',
    name: 'payment_method',
    component: () => import(/* webpackChunkName: "payment_method" */ '../views/PaymentMethodView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Payment Methods',
          path: '/ecommerce/settings/payment-methods',
        },
      ],
    },
    children: [],
  },
];

export default PaymentMethod;
